import { useEffect, useState } from 'react';
import { BsCalendarRange } from 'react-icons/bs';

import { matchingPreset, periodPresets, presetRange } from '../../helpers/period';

/**
 * Picking a period is two gestures in one: the shortcut everybody uses and the
 * two dates somebody occasionally needs. The dates are edited on a draft so
 * typing a start date does not fire off a query for a period that ends before
 * it begins; a preset applies at once, because there is nothing to complete.
 */
export default function PeriodPicker({ period, onChange, disabled }) {

  const [draft, setDraft] = useState(period);
  const active = matchingPreset(period);

  useEffect(() => {
    setDraft(period);
  }, [period]);

  const applyPreset = (key) => {
    const range = presetRange(key);

    if (range) {
      setDraft(range);
      onChange(range);
    }
  };

  const submit = (event) => {
    event.preventDefault();

    if (draft.start <= draft.end) {
      onChange(draft);
    }
  };

  const invalid = draft.start > draft.end;

  return (
    <div className="card border-0 shadow p-3 p-md-4">
      <div className="d-flex flex-wrap gap-2 mb-3">
        {periodPresets.map((preset) => (
          <button
            key={preset.key}
            type="button"
            disabled={disabled}
            className={`btn btn-sm ${active === preset.key ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => applyPreset(preset.key)}
          >
            {preset.label}
          </button>
        ))}
      </div>

      <form onSubmit={submit}>
        <div className="row g-2 align-items-end">
          <div className="col-6 col-md-4 col-lg-3">
            <label htmlFor="start" className="form-label small mb-1">Van</label>
            <input
              id="start"
              type="date"
              className="form-control"
              value={draft.start}
              max={draft.end}
              onChange={(event) => setDraft({ ...draft, start: event.target.value })}
            />
          </div>
          <div className="col-6 col-md-4 col-lg-3">
            <label htmlFor="end" className="form-label small mb-1">Tot en met</label>
            <input
              id="end"
              type="date"
              className="form-control"
              value={draft.end}
              min={draft.start}
              onChange={(event) => setDraft({ ...draft, end: event.target.value })}
            />
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <button type="submit" className="btn btn-primary w-100" disabled={disabled || invalid}>
              <BsCalendarRange className="me-2" />
              Toon periode
            </button>
          </div>
        </div>
        {invalid ? (
          <p className="form-text text-danger mb-0">De startdatum ligt na de einddatum.</p>
        ) : null}
      </form>
    </div>
  );
}
